import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=4fb3448b&scoped=true"
import script from "./Markdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./Markdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=4fb3448b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3448b",
  null
  
)

export default component.exports